export enum ActionType {
  DELETE_VAULT_ITEM = 'deleteSelectedVaultItem',
  FETCH_SCHEMA_DRIS = 'fetchSchemaDRIs',
  FETCH_SCHEMAS_TITLE = 'fetchSchemasTitle',
  FETCH_REPOS = 'fetchRepos',
  FETCH_VAULT_ITEMS = 'fetchVaultItems',
  FETCH_VAULT_ITEM = 'fetchVaultItem',
  RESET_VAULT_ITEMS = 'resetVaultItems',
  TOGGLE_UI_IS_FLUID = 'toggleUiIsFluid',
  UPDATE_VAULT_ITEM = 'updateVaultItem',
}
